function enterEntrance(e) {
    const entranceHoverText = e.currentTarget.querySelector('.entrances__hover-wrap');

    if (entranceHoverText) {
        entranceHoverText.style.height = `${entranceHoverText.scrollHeight}px`;
    }
}

function leaveEntrance(e) {
    const entranceHoverText = e.currentTarget.querySelector('.entrances__hover-wrap');

    if (entranceHoverText) {
        entranceHoverText.removeAttribute('style');
    }
}

export function setupEntrances() {
    const entranceItems = document.querySelectorAll('.entrances__item');

    entranceItems.forEach(entranceItem => {
        const entranceHasHoverText = entranceItem.querySelector('.entrances__hover-wrap');

        if (entranceHasHoverText) {
            entranceItem.addEventListener('mouseenter', enterEntrance);
            entranceItem.addEventListener('mouseleave', leaveEntrance);
        }
    });
}
